import type { FormAction } from "src/components/Form/Form.types.ts";
import { createModuleI18nNamespaces } from "src/system/createModuleI18nNamespaces.ts";
type FormTranslationProps = {
  type: "form";
  formType: FormAction;
  tab?: string;
};
type ListTranslationProps = {
  type: "list";
};
type LayoutTranslationProps = {
  type: "layout";
};

type CommonProps = {
  resource: string;
};

export type GetErpTranslationNamespaceProps = CommonProps &
  (FormTranslationProps | ListTranslationProps | LayoutTranslationProps);

export const getErpTranslationNamespace = (
  props: GetErpTranslationNamespaceProps,
) => {
  const { resource } = props;
  const namespaces = createModuleI18nNamespaces({
    resource,
  });
  if (props.type === "form") {
    return namespaces.form({
      type: props.formType,
      tab: props.tab,
    });
  }
  if (props.type === "layout") {
    return namespaces.layout();
  }
  return namespaces.list();
};
